import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import { checkPermission } from 'utils/checkPermission';
import Sucursal from './Sucursal';
import AddBranchOfficeModal from '../../modals/AddBranchOfficeModal';
import SoftBadge from 'components/common/SoftBadge';

export const RolesPermissions = ({ user, userLogged }) => {
  const [showModal, setShowModal] = useState(false);

  const [branchOfficesUser, setBranchOfficesUser] = useState(
    user?.branchOfficeToUser?.map(botu => ({
      branchOfficeToUserId: botu.id,
      branchOfficeId: botu.branchOffice.id,
      branchOfficeName: botu.branchOffice.branch_office_name,
      branchOfficeAddress: botu.branchOffice.address,
      roleId: botu.role_id,
      roleName: botu.role.name,
      active: botu.active,
      permissions: botu.role.roleToPermission
    })) || []
  );
  useEffect(() => {
    setBranchOfficesUser(
      user?.branchOfficeToUser?.map(botu => ({
        branchOfficeToUserId: botu.id,
        branchOfficeId: botu.branchOffice.id,
        branchOfficeName: botu.branchOffice.branch_office_name,
        branchOfficeAddress: botu.branchOffice.address,
        roleId: botu.role_id,
        roleName: botu.role.name,
        active: botu.active,
        permissions: botu.role.roleToPermission
      })) || []
    );
  }, [user?.branchOfficeToUser]);
  return (
    <>
      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div>
            <Card.Title>Roles y Permisos</Card.Title>
            <Card.Text>
              {user?.id === userLogged?.id ? (
                <>Tiene los siguientes roles y permisos asignados</>
              ) : (
                <>
                  Asigne los roles y permisos de{' '}
                  <span className="text-decoration-underline fw-bold">
                    {user?.fullname}
                  </span>
                </>
              )}
            </Card.Text>
            {userLogged &&
              checkPermission('Edit users', userLogged) &&
              user?.id !== userLogged.id && (
                <ButtonCreate
                  text="Añadir Sucursal"
                  variant="primary"
                  funcion={() => setShowModal(true)}
                  className="w-100"
                />
              )}
          </div>
        </Card.Header>

        <Card.Body className="pt-0">
          {(userLogged?.id === user?.id &&
            userLogged?.typeOfUser !== 'admin') ||
          (userLogged?.id !== user?.id &&
            userLogged?.typeOfUser === 'admin') ? (
            branchOfficesUser.map((branchOfficeToUser, index) => (
              <Sucursal
                key={branchOfficeToUser.branchOfficeId}
                branchOfficeToUser={branchOfficeToUser}
                isLast={index === branchOfficesUser.length - 1}
                isFirst={index === 0}
                userLogged={userLogged}
                setBranchOfficesUser={setBranchOfficesUser}
                userId={user.id}
              />
            ))
          ) : (
            <>
              <style>
                {`
                  
                  @media (min-width: 576px) {
                    .custom-fs {
                      font-size: 1.25rem;
                    }
                  }
                  @media (max-width: 575px) {
                    .custom-fs {
                      font-size: 1rem;

                    }
                  }

                `}
              </style>

              <SoftBadge className="custom-fs" bg="info">
                <strong>Usuario Administrador</strong>
              </SoftBadge>
            </>
          )}
        </Card.Body>
      </Card>

      <AddBranchOfficeModal
        userLogged={userLogged}
        show={showModal}
        setShow={setShowModal}
        setBranchOfficesUser={setBranchOfficesUser}
        branchOfficesUser={branchOfficesUser}
      />
    </>
  );
};
RolesPermissions.propTypes = {
  user: PropTypes.object,
  userLogged: PropTypes.object
};
